<template>
  <div>
    <car-heading></car-heading>
    <div class="mt-3">
      <router-link
        tag="button"
        :to="'/'+$route.params.car"
        type="button"
        class="btn btn-t1-secondary"
      >
        <i class="fa fa-fw fa-pencil-square-o"></i>Palaa muokkaamaan
      </router-link>
      <button
        @click="sendForm"
        type="button"
        class="btn btn-t1-primary"
      >Lähetä</button>
    </div>
    <div class="mt-3">
      <form-head
        ref="form-head"
        :disabled="disabled"
      ></form-head>
      <fieldset class="form-group">
        <div class="checkbox">
          <input
            id="optionsCheck1"
            type="checkbox"
            v-model="contact"
          >
          <label
            for="optionsCheck1"
            style="whitespace: pre-wrap;"
          >Haluan, että jälleenmyyjä ottaa minuun yhteyttä.</label>
        </div>
        <input
          type="tel"
          class="form-control"
          id="phone"
          placeholder="Puhelinnumero"
          v-model="phone"
          v-if="contact"
          novalidate
        >
      </fieldset>
      <p class="support-text mb-2 mb-md-4">Huomaathan, että valintojesi täyttämisen nopeuttamiseksi olemme jo esitäyttäneet oletusvalinnat, jotka voit jättää valituiksi tai vaihtaa haluamaksesi.</p>
      <h2 class="mb-1 mb-md-3">Yhteenveto autoni asetuksista</h2>
      <summary-list :data="data"></summary-list>
    </div>
    <router-link
      tag="button"
      :to="'/'+$route.params.car"
      type="button"
      class="btn btn-t1-secondary"
    >
      <i class="fa fa-fw fa-pencil-square-o"></i>Palaa muokkaamaan
    </router-link>
    <button
      @click="sendForm"
      type="button"
      class="btn btn-t1-primary"
    >Lähetä</button>
    <div class="my-4"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import FormHead from "../components/FormHead";
import CarHeading from "../components/CarHeading";
import Axios from "axios";
import CONF from "../config";
import bus from "../bus";
const SummaryList = () =>
  import(/* webpackChunkName: "summarylist" */ "../components/SummaryList");
export default {
  data() {
    return {
      contact: false,
      disabled: true
    };
  },
  computed: {
    ...mapGetters({
      getTemplateById: "getTemplateById",
      getForm: "getForm",
      getDefaults: "getDefaults",
      getCarByKey: "getCarByKey"
    }),
    phone: {
      get() {
        return this.$store.state.form.form.phone;
      },
      set(value) {
        this.$store.commit("setPhone", value);
      }
    },
    car() {
      return this.getCarByKey(this.$route.params.car);
    },
    template() {
      return this.getTemplateById(this.car.template_id);
    },
    data() {
      if (this.template) {
        let data = JSON.parse(this.template.data);
        return data;
      }
      return 0;
    }
  },
  methods: {
    sendForm() {
      window.console.log(bus);
      let errors = bus.$emit("validate").errors.items;
      let form = this.getForm;
      form.phone = this.phone;
      setTimeout(() => {
        if (errors.length) {
          return;
        }
        Axios.post(CONF.apiUrl + "submit", {
          template: this.template,
          form: form,
          defaults: this.getDefaults
        })
          .then(() => {
            this.$router.push("kiitos");
          })
          .catch(e => window.console.error(e));
      }, 200);
    }
  },
  mounted() {
    window.scrollTo(0, 0);
    // window.ga("set", "page", '/summary');
    // window.ga("send", "pageview");
  },
  components: {
    FormHead,
    CarHeading,
    SummaryList
  }
};
</script>

<style lang="scss">
.v-select {
  background: #f0f0f0;

  .dropdown-toggle {
    border: 0;
    &:after {
      visibility: hidden;
    }
  }

  .open-indicator:before {
    border-color: #e50000;
  }
}
.image {
  max-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
  img {
    max-width: 100%;
    max-height: 100%;
  }
}
</style>
